<template>
  <div class="wh100">
    <div class="top-bg"></div>
    <div class="top">
      <div class="tabbar-title">山东矿机培训管理系统</div>
      <!-- <div class="sdkj-view">
        <div @click="userLogin" v-if="!userView" class="user-container">
          <van-image
            width="5rem"
            height="5rem"
            fit="fill"
            round
            :src="gravatar"
          />
          <div class="user-message">
            <div style="font-size: 1rem">点此登录后查看信息</div>
          </div>
        </div>
        <div v-if="userView" class="user-container">
          <van-image width="5rem" height="5rem" fit="fill" round :src="headimgurl" />
          <div class="user-message">
            <div style="font-size: 1.2rem">{{ nickname }}</div>
          </div>
        </div>
      </div> -->
      <div v-if="userView" class="sdkj-view">
        <van-cell is-link @click="userShow" center>
          <!-- 使用 title 插槽来自定义标题 -->
          <template #title>
            <div class="xxws-container">
              <van-image width="1rem" height="1rem" fit="fill" :src="xxws" />
              <span class="custom-title">信息完善</span>
            </div>
          </template>
        </van-cell>

        <div v-show="isMessage" class="checkout" @click="userBack">退出登录</div>
      </div>
    </div>

    <van-popup v-model="showUserMessage" position="right" :lock-scroll="false" :style="{ width: '100%', height: '100%' }">
      <user v-if="showUserMessage" @fatherMethod="Back" />
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from "vant";
import user from "./userMessage.vue";
export default {
  name: "my",
  components: { user },
  computed: {},
  data() {
    return {
      xxws: require("../../assets/icon/icon_xxws.png"),
      gravatar: require("../../assets/icon/gravatar.png"),
      showUserMessage: false,
      isMessage: false,
      userView: true,
      headimgurl: "",
      nickname: "",
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.isShowOut();
  },
  destroyed() {},
  methods: {
    userShow() {
      this.showUserMessage = true;
    },
    isShowOut() {
      if (localStorage.getItem("IdCard")) {
        this.isMessage = true;
      } else {
        this.isMessage = false;
      }
    },
    Back() {
      this.showUserMessage = false;
      window.location.reload();
    },
    userLogin() {
      window.location.href = `http://open.weixin.qq.com/connect/oauth2/authorize?appid=` + this.$store.getters.appconfig.wxConfig.appid + `&redirect_uri=https://200.200.201.18:8082` + `&response_type=code&scope=snsapi_userinfo&state=${new Date().getTime()}#wechat_redirect`;
    },
    userBack() {
      Dialog.confirm({
        title: "确认退出登录",
      })
        .then(() => {
          localStorage.setItem("openid", "");
          localStorage.setItem("IdCard", "");
          localStorage.setItem("headimgurl", "");
          localStorage.setItem("nickname", "");
          localStorage.setItem("code", "");
          window.location.reload();
          // window.location.href = `https://` + this.$store.getters.appconfig.wxConfig.webUrl + `?version=${new Date().getTime()}`;
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.top-bg {
  position: fixed;
  top: 0;
  height: 220px;
  background: #0181fe;
  width: 100%;
  z-index: 0;
}

.top {
  width: 100%;
  padding: 0 13px;
  box-sizing: border-box;
  position: relative;

  .tabbar-title {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: white;
    z-index: 1 !important;
    height: 50px;
    z-index: 1;
    font-weight: bold;
    font-size: 1.1rem;
  }
}
.sdkj-view {
  margin-top: 15px;
  z-index: 999 !important;
  width: 100%;
  padding: 13px;
  border-radius: 10px;
  box-sizing: border-box;
  background: #fefefe;
}
.tabbar-container {
  text-align: center;
  width: 100%;
  margin-top: 1.5rem;
  color: white;
  font-weight: bold;
  font-size: 1.1rem;
}

.user-container {
  z-index: 1;
  width: 100%;
  background: rgba($color: #ffffff, $alpha: 0.25);
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;

  .user-message {
    margin-left: 20px;
    color: #333333;
  }
}
.custom-title {
  margin-left: 15px;
}
.xxws-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.checkout {
  height: 44px;
  border-radius: 10px;
  margin-top: 1rem;
  display: flex;
  align-items: row;
  align-items: center;
  justify-content: center;
  background: #d25252;
  color: #ffffff;
  font-size: 1rem;
}

.checkin {
  width: 90%;
  height: 44px;
  margin-left: 5%;
  border-radius: 10px;
  margin-top: 1rem;
  display: flex;
  align-items: row;
  align-items: center;
  justify-content: center;
  background: #01c65a;
  color: #ffffff;
  font-size: 1rem;
}
</style>
